import { render, staticRenderFns } from "./SectionMenu.vue?vue&type=template&id=23e72bd6&"
import script from "./SectionMenu.vue?vue&type=script&lang=js&"
export * from "./SectionMenu.vue?vue&type=script&lang=js&"
import style0 from "./SectionMenu.vue?vue&type=style&index=0&id=23e72bd6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports